'use client';

import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  label: string;
  icon: string;
}

interface NewsFiltersProps {
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export default function NewsFilters({
  activeCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
}: NewsFiltersProps) {
  const categories: Category[] = [
    { id: 'cat_all', label: 'All News', icon: 'NewspaperIcon' },
    { id: 'cat_stocks', label: 'Stocks', icon: 'ChartBarIcon' },
    { id: 'cat_commodities', label: 'Commodities', icon: 'CubeIcon' },
    { id: 'cat_forex', label: 'Forex', icon: 'BanknotesIcon' },
    { id: 'cat_economy', label: 'Economy', icon: 'BuildingLibraryIcon' },
    { id: 'cat_policy', label: 'Policy', icon: 'DocumentTextIcon' },
  ];

  return (
    <div className="mb-8">
      {/* Search Bar */}
      <div className="mb-6">
        <div className="relative max-w-2xl">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search financial news..."
            className="w-full px-6 py-4 pl-14 bg-card border border-border rounded-xl text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary transition-colors"
          />
          <Icon
            name="MagnifyingGlassIcon"
            size={24}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
        </div>
      </div>

      {/* Category Filters */}
      <div className="flex items-center gap-3 overflow-x-auto scrollbar-thin pb-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-full font-medium transition-all whitespace-nowrap ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground'
                : 'bg-card border border-border text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Icon name={category.icon as any} size={18} />
            {category.label}
          </button>
        ))}
      </div>
    </div>
  );
}